import { FC, Fragment } from 'react';
import { Link } from 'react-router';
import { ProductVM } from '../../../common/view-model';
import {
	firstLevelCategoryIdentifier,
	parentCategoryIdentifier,
	secondLevelCategoryIdentifier
} from '../../../helpers/paramsUrlIndetifiers';
import './DetailBreadcrumbComponent.scss';

interface IDetailBreadcrumbComponentProps {
	product: ProductVM | undefined;
}
const allProductsText = 'All categories';

export const DetailBreadcrumbComponent: FC<IDetailBreadcrumbComponentProps> = ({ product }) => {
	const getProductsUrl = (index: number, id?: string) => {
		if (!id) return '/products';

		let parameter = firstLevelCategoryIdentifier;
		if (index === 0) {
			parameter = parentCategoryIdentifier;
		} else if (index === 1) {
			parameter = secondLevelCategoryIdentifier;
		}
		const params = new URLSearchParams([[parameter, id]]);

		return `/products?${params.toString()}`;
	};

	const renderBreadcrumb = (index: number) => {
		const hasMore = product?.taxonomy && index < product.taxonomy.length - 1;
		const name = product?.taxonomy && product.taxonomy[index]?.name;
		const id = product?.taxonomy?.[index]?.id;

		return (
			<Fragment key={index}>
				{hasMore ? (
					<Link className='breadcrumb-text has-more' to={getProductsUrl(index, id)}>
						{name === 'All Categories' ? 'All Products' : name}
					</Link>
				) : (
					<span className='breadcrumb-text last'>
						{name === 'All Categories' ? 'All Products' : name}
					</span>
				)}
				{hasMore && <span className='breadcrumb-separator'>/</span>}
			</Fragment>
		);
	};

	return (
		<div className='detail-breadcrumb-container'>
			{product?.taxonomy?.length ? (
				<>
					<Link className='breadcrumb-text has-more' to='/products'>
						{allProductsText}
					</Link>
					<span className='breadcrumb-separator'>/</span>
				</>
			) : null}
			{product?.taxonomy && product.taxonomy.map((_, index) => renderBreadcrumb(index))}
		</div>
	);
};
